/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventanalytics1Inputs */

const en_eventanalytics1 = /** @type {(inputs: Eventanalytics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event analytics`)
};

const de_eventanalytics1 = /** @type {(inputs: Eventanalytics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken zum Event`)
};

/**
* | output |
* | --- |
* | "Event analytics" |
*
* @param {Eventanalytics1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventanalytics1 = /** @type {((inputs?: Eventanalytics1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventanalytics1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventanalytics1(inputs)
	return de_eventanalytics1(inputs)
});
export { eventanalytics1 as "eventAnalytics" }